import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';

import { get } from 'lodash';

import { formatFootage } from '../../utils/number-util';
import { formatUOMLabel } from '../../utils/format-utils';

import classes from './PanelInsert.module.css';

const SitePanelInsert = ({
    node,
    ...props
}) => {
    const [address, setAddress] = useState('');
    const [fuelTypes, setFuelTypes] = useState('');

    useEffect(() => {
        const formattedAddress = get(node, 'address.formattedAddress', '');

        let typeArray = [];

        if (node.fuelTypes) {
            node.fuelTypes.forEach(type => {
                typeArray.push(type.name);
            });
        }

        const fuelTypesFormatted = typeArray.join(', ');

        setAddress(formattedAddress ? formattedAddress : '');
        setFuelTypes(fuelTypesFormatted);
    }, [node]);

    return (
        <dl className={classes.agentInfo}>
            <dt>Name</dt>
            <dd>{node.name}</dd>

            <dt>Address</dt>
            <dd>{address}</dd>

            <dt>Building Type</dt>
            <dd>{node.buildingType.name}</dd>

            <dt>Area</dt>
            <dd>{formatFootage(node.squareFootage) + ' ' + formatUOMLabel(node.squareAreaUOM)}</dd>

            <dt>Fuel Types</dt>
            <dd>{fuelTypes}</dd>

            <dt>Sales Contact</dt>
            <dd>{node.salesContact.name}</dd>

            <dt>Facilities Contact</dt>
            <dd>{node.facilitiesContact.name}</dd>

            <dt>Energy Contact</dt>
            <dd>{node.energyContact.name}</dd>
        </dl>
    );
};

SitePanelInsert.defaultProps = {
    node: {}
};

SitePanelInsert.propTypes = {
    node: object.isRequired
};

export default SitePanelInsert;
